var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManArmFore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105px",
    height: "72px",
    viewBox: "0 0 105 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ManArmFore") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ManArmFore",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M79.1602286,55.339601 L79.1602286,55.3426242 C78.2905965,59.6174016 81.0494293,63.8347386 85.2876362,64.7134765 L95.5432971,66.8377647 C99.7914997,67.7165026 103.969732,64.9361841 104.839364,60.660399 L104.839364,60.6573758 C105.708996,56.3825984 102.960159,52.1662691 98.7119565,51.2865235 L88.4562955,49.1622353 C84.2180887,48.2834974 80.0398564,51.0638159 79.1602286,55.339601",
    id: "Fill-134",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,64.1752358 C85,64.1752358 50.3341493,73.6396892 39.2561924,71.7506599 C28.1782355,69.8626467 33.0807784,49.397316 33.0807784,49.397316 L83.538187,49 L85,64.1752358",
    id: "Fill-135",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,23.3802877 L24.1511322,68.2643606 C28.454498,79.7041716 56.5470306,62.4232622 50.0215998,49.3066188 C49.6093615,48.4791298 24.1511322,0 24.1511322,0 C24.1511322,0 1.59868027,7.07388803 0,23.3802877",
    id: "Fill-136",
    fill: "#B1BCCC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManArmFore);
export default __webpack_public_path__ + "static/media/ManArmFore.d9b6750460565791010b8fc69b7fcd94.svg";
export { ForwardRef as ReactComponent };